/**
 * What the model may say about one message. Flat shapes on purpose: closed
 * enums plus `value` strings, so structured outputs can hold the model to it
 * and so nothing here can express a party as free text.
 */
import { z } from 'zod'

export const PartyRefKind = z.enum([
  'speaker',
  'speaker_org',
  'recipient',
  'recipient_org',
  'named',
  'unresolved',
])

export const PartyRef = z.object({
  kind: PartyRefKind,
  /** recipient / recipient_org: the recipient's email address; named: the name as written; else null. */
  value: z.string().nullable(),
})

export const CandidateOutput = z.object({
  proposition: z.string(),
  claim_type: z.enum(['commitment', 'expectation', 'request', 'modification', 'resolution']),
  modality: z.enum(['will', 'try', 'intend', 'may', 'request', 'question', 'other']),
  /** Verbatim, contiguous excerpt of NEW TEXT. */
  exact_quote: z.string(),
  timing_kind: z.enum(['exact', 'date', 'range', 'relative', 'none']),
  /** The timing words exactly as written in the span, or null. */
  timing_text: z.string().nullable(),
  /** A verbatim clause from the span, or null. */
  condition: z.string().nullable(),
  owed_by: PartyRef,
  owed_to: PartyRef,
  responsible_actor: PartyRef,
  promise_scope: z.enum(['personal', 'organizational', 'collective', 'uncertain']),
  /** One sentence: why the direction is what it is. Trace shows it. */
  direction_reason: z.string(),
})

export const ExtractOutput = z.object({
  candidates: z.array(CandidateOutput),
})

export type PartyRefOutput = z.infer<typeof PartyRef>
export type CandidateOutputT = z.infer<typeof CandidateOutput>
export type ExtractOutputT = z.infer<typeof ExtractOutput>
